(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 4405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2057);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_AppContainer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1503);
/* harmony import */ var _components_Footer_Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6268);
/* harmony import */ var _components_utils_local_policy__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5200);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2676);







var Contact = function Contact(props) {
  var _storeData$legalInfo;

  var storeData = props.storeData;
  var contacts = storeData !== null && storeData !== void 0 && storeData.legalInfo && storeData !== null && storeData !== void 0 && (_storeData$legalInfo = storeData.legalInfo) !== null && _storeData$legalInfo !== void 0 && _storeData$legalInfo.contacts ? storeData.legalInfo.contacts : (_components_utils_local_policy__WEBPACK_IMPORTED_MODULE_3__/* .localLegalInfo */ .y === null || _components_utils_local_policy__WEBPACK_IMPORTED_MODULE_3__/* .localLegalInfo */ .y === void 0 ? void 0 : _components_utils_local_policy__WEBPACK_IMPORTED_MODULE_3__/* .localLegalInfo.contacts */ .y.contacts) || "";
  console.log(contacts);
  contacts = contacts.replace("{{store email}}", (storeData === null || storeData === void 0 ? void 0 : storeData.email) || "NA");
  contacts = contacts.replace("{{store phone}}", "").replace("Phone", "");
  contacts = contacts.replaceAll("{{store instagram}}", (storeData === null || storeData === void 0 ? void 0 : storeData.instagramHandle) || "NA");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_components_AppContainer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        name: "robots",
        content: "noindex, nofollow, noarchive, nosnippet"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("title", {
        children: "Contact Us"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("main", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("h2", {
        className: "sidepage-title",
        children: "Contact Us"
      }), contacts.trim() !== "" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "sidepage-content",
        dangerouslySetInnerHTML: {
          __html: contacts
        }
      }) : null]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Contact);

/***/ }),

/***/ 9892:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(4405);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9248,7234,6166,3352,9774,2888,179], function() { return __webpack_exec__(9892); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);